<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import { required, email } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
/*
 * Edit Agent Availability
 */
export default {
  page: {
    title: "Edit Agent Availability",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      name: "Edit Agent Availability",
      title: "Edit Agent Availability",
      headers: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      items: [
        {
          text: "Agent Availability",
          href: "/agent-availability",
        },
      ],
      form: {
        name: "",
        email: "",
        mobile_phone: "",
        password: "",
        agent: "",
        time:""
      },
      errors: null,
      submitted: false,
      pending: false,
      agents : [],
      times : [],
      agent: "",
      time: ""
    };
  },
  validations: {
    form: {
      agent: { required },
      time: { required },
    },
  },
  methods: {
    async getAdmins()
    {
      let that = this;
      that.pending = true;
      await axios.get(appConfig.admins.agent).then(function (response) {
        that.pending = false;
        that.agents = response.data.data;
      });
    },
    async getTimeSlots()
    {
      let that = this;
      that.pending = true;
      await axios.get(appConfig.time_slots.list).then(function (response) {
        that.pending = false;
        that.times = response.data.slots;
      });
    },
    async getItem()
    {
      let that = this;
      await axios
        .get(appConfig.agent_avalability.list + '/' + this.$route.params.id)
        .then(function (response) {
          that.agent = response.data.agent;
          that.time = response.data.time;
          that.form.agent = that.agent.id;
          that.form.time = that.time.id;
        });
    },
    async create() {
      let that = this;
      that.submitted = true;
      let formData = new FormData();

      formData.append("admin_id", that.form.agent);
      formData.append("time_slot_id", that.form.time);

      await axios
        .post(appConfig.agent_avalability.update  + '/' + this.$route.params.id,formData, that.headers)
          .then(function (res) {
            // console.log(res);
            that.submitted = false;
            that.$iziToast.success({
              message: "Saved Successfully!",
              position: "bottomCenter",
            });
          that.$router.push({ path: "/agent-availability" });
            })
          .catch(function (error) {
            that.submitted = false;
            if (error.response) {
              that.errors = error.response.data.errors;
              window.scrollTo(0, 0);
            }
          });
    },
  },
  created() {
    this.getItem();
    this.getAdmins();
    this.getTimeSlots();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="error_area">
          <div class="card-body">
            <FormValidation :errors="errors" />

            <form class="needs-validation" @submit.prevent="create">
              <fieldset :disabled="submitted || pending">
                <div class="row">
                  <div class="col-sm-7">
                    <div class="form-group">
                      <label class="">Agent Name</label>
                      <select v-model="form.agent" class="form-control">
                        <option selected="true" disabled="disabled">
                          Select Agent Name
                        </option>
                        <option v-for="agent in agents" :key="agent.id" :value="agent.id">
                          {{ agent.name }}
                        </option>
                      </select>
                    </div>
                    <!-- form-group -->
                    <!-- form-group -->
                  </div>
                  <div class="col-sm-7">
                    <div class="form-group">
                      <label class="">Time Slot</label>
                      <select v-model="form.time" class="form-control">
                        <option selected="true" disabled="disabled">
                          Select Time Slot
                        </option>
                        <option v-for="time in times" :key="time.id" :value="time.id">
                          {{ time.name }}
                        </option>
                      </select>
                    </div>
                    <!-- form-group -->

                    <!-- form-group -->
                  </div>
                </div>
                <!-- row -->

                <div class="col-lg-12 mt-4 text-right">
                  <button
                    class="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                  >
                    <span
                      v-show="submitted || pending"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-show="!submitted && !pending">Update</span>
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped></style>
